import { ScopeOfPracticeEnum } from '@umss/shared/utils';

export interface FacilityBillableRateDto {
  id: string;
  createdAt: string;
  updatedAt: string;
  facilityId: string;
  facilityName: string;
  scopeOfPractice: ScopeOfPracticeEnum;
  scopeOfPracticeDisplay: string;
  hourlyRate: number;
  urgentHourlyRate?: number;
  differentialRate?: number;
  isDifferentialModified: boolean;
  totalRate: number;
  totalUrgentRate?: number;
  isBaseRateOverridden: boolean;
  isActive: boolean;
  scheduledRates: FacilityBillableScheduledRateDto[];
  /** Present when isDifferentialModified === false; contains active and future global differential snapshots */
  scheduledDifferentialRates?: ScheduledDifferentialRateDto[];
}

export interface FacilityBillableScheduledRateDto {
  id: string;
  rate: number;
  effectiveFrom: string;
  effectiveTo: string;
}

export interface ScheduledDifferentialRateDto {
  id: string;
  globalDifferentialRateId: string;
  differentialRate: number;
  effectiveFrom: string; // ISO datetime
  effectiveTo: string; // ISO datetime
  description?: string;
  createdAt: string;
  updatedAt: string;
}
